import {
	pricesAndCostsApply,
	pricesAndCostsCalculate,
	pricesAndCostsConfirm,
	pricesAndCostsNewValue,
	pricesAndCostsPaginate,
	pricesAndCostsVerify
} from 'api/PricesAndCostsMassiveUpload'
import {
	SET_PRICES_AND_COSTS_APPLY,
	SET_PRICES_AND_COSTS_CALCULATE,
	SET_PRICES_AND_COSTS_CONFIRM,
	SET_PRICES_AND_COSTS_NEW_VALUE,
	SET_PRICES_AND_COSTS_PAGINATE,
	VERIFY_PRICES_AND_COSTS
} from 'constants/ActionsTypes'
import {
	IPricesAndCostsApplySaga,
	IPricesAndCostsCalculateSaga,
	IPricesAndCostsConfirmSaga,
	IPricesAndCostsNewValueSaga,
	IPricesAndCostsPaginateSaga
} from 'models/PricesAndCostsMassiveUploadInterface'
import { all, call, fork, put, takeLatest } from 'redux-saga/effects'
import {
	pricesAndCostsApplySuccess,
	pricesAndCostsCalculateSuccess,
	pricesAndCostsConfirmSuccess,
	pricesAndCostsNewValueSuccess,
	pricesAndCostsPaginateSuccess,
	pricesAndCostsVerifySuccess
} from '../actions'

function* pricesAndCostsApplyReq({ payload }: IPricesAndCostsApplySaga): any {
	try {
		const values: any = yield call(pricesAndCostsApply, payload)
		yield put(pricesAndCostsApplySuccess(values))
	} catch (error) {}
}
function* pricesAndCostsCalculateReq({
	payload
}: IPricesAndCostsCalculateSaga): any {
	try {
		const values: any = yield call(pricesAndCostsCalculate, payload)
		yield put(pricesAndCostsCalculateSuccess(values))
	} catch (error) {}
}
function* pricesAndCostsConfirmReq({
	payload
}: IPricesAndCostsConfirmSaga): any {
	try {
		const values: any = yield call(pricesAndCostsConfirm, payload)
		yield put(pricesAndCostsConfirmSuccess(values))
	} catch (error) {}
}
function* pricesAndCostsPaginateReq({
	payload
}: IPricesAndCostsPaginateSaga): any {
	try {
		const values: any = yield call(pricesAndCostsPaginate, payload)
		yield put(pricesAndCostsPaginateSuccess(values))
	} catch (error) {}
}
function* pricesAndCostsVerifyReq({ payload }: any): any {
	try {
		const values: any = yield call(pricesAndCostsVerify, payload)
		yield put(pricesAndCostsVerifySuccess(values))
	} catch (error) {}
}
function* pricesAndCostsNewValueReq({
	payload
}: IPricesAndCostsNewValueSaga): any {
	try {
		const values: any = yield call(pricesAndCostsNewValue, payload)
		yield put(pricesAndCostsNewValueSuccess(values))
	} catch (error) {}
}

export function* pricesAndCostsApplySaga() {
	yield takeLatest(SET_PRICES_AND_COSTS_APPLY, pricesAndCostsApplyReq)
}
export function* pricesAndCostsCalculateSaga() {
	yield takeLatest(SET_PRICES_AND_COSTS_CALCULATE, pricesAndCostsCalculateReq)
}
export function* pricesAndCostsConfirmSaga() {
	yield takeLatest(SET_PRICES_AND_COSTS_CONFIRM, pricesAndCostsConfirmReq)
}
export function* pricesAndCostsPaginateSaga() {
	yield takeLatest(SET_PRICES_AND_COSTS_PAGINATE, pricesAndCostsPaginateReq)
}
export function* pricesAndCostsVerifySaga() {
	yield takeLatest(VERIFY_PRICES_AND_COSTS, pricesAndCostsVerifyReq)
}
export function* pricesAndCostsNewValueSaga() {
	yield takeLatest(SET_PRICES_AND_COSTS_NEW_VALUE, pricesAndCostsNewValueReq)
}

export default function* rootSaga() {
	yield all([
		fork(pricesAndCostsApplySaga),
		fork(pricesAndCostsCalculateSaga),
		fork(pricesAndCostsConfirmSaga),
		fork(pricesAndCostsPaginateSaga),
		fork(pricesAndCostsVerifySaga),
		fork(pricesAndCostsNewValueSaga)
	])
}
